module.exports = __webpack_public_path__ + "static/media/Swashakthi-SHG-Key-Benefits.92a3dcd3.webp";